import React from "react";
import Head from "next/head";
import BasePage from "../components/BasePage";
import { jsx as ___EmotionJSX } from "@emotion/react";

var SearchPage = function SearchPage(props) {
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Head, null, ___EmotionJSX("meta", {
    name: "robots",
    content: "follow,noindex"
  })), ___EmotionJSX(BasePage, props));
};

export default SearchPage;